import { createSelector } from 'reselect'

const getLightbox = state => state.lightbox

export const getLightboxIdle = createSelector(
  [getLightbox],
  lightbox => lightbox.get('idle')
)

export const getLightboxMediaType = createSelector(
  [getLightbox],
  lightbox => lightbox.get('mediaType')
)


// WEBPACK FOOTER //
// ./src/components/lightbox-container/selectors.js